import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Standard from "../Standard";
import logo from "../../branding/current/logo.png";
import logoDark from "../../branding/current/logo_dark.png";

export class CallCompleted extends React.Component {
  completed = () => {
    return <div></div>;
  };

  render() {
    const { contrast, l10n } = this.props;
    return (
      <Standard
        logo={logo}
        logoDark={logoDark}
        contrast={contrast}
        l10n={l10n}
        include={this.completed()}
      />
    );
  }
}

CallCompleted.propTypes = {
  l10n: PropTypes.func.isRequired,
  contrast: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  l10n: state.config.text,
  contrast: state.accessibility.isHighContrast,
});

export default connect(mapStateToProps)(CallCompleted);






// WEBPACK FOOTER //
// ./src/kiosk/callStates/CallCompleted.jsx